import { render, staticRenderFns } from "./ExchangeItem.vue?vue&type=template&id=d8a1b26e"
import script from "./exchange-item.ts?vue&type=script&lang=ts&external"
export * from "./exchange-item.ts?vue&type=script&lang=ts&external"
import style0 from "./exchange-item.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports